import script from "./email-label-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./email-label-modal.vue?vue&type=script&setup=true&lang=js"

import "./email-label-modal.vue?vue&type=style&index=0&id=766bdd23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766bdd23"]])

export default __exports__